import React from 'react';
import { Button, Icon } from 'antd';

import './styles/CustomBtn.css'

class CustomBtn extends React.Component {
    render(){
        const {
            color = 'black',
            borderColor = color,
            textColor = 'white',
            text = 'Submit',
            onClick,
        } = this.props;

        return(
            <Button 
                type="primary"
                className="axss-custom-btn" 
                onClick={onClick}
                style={{backgroundColor:color, borderColor:borderColor, color: textColor }}
            >
                {this.props.iconType && <Icon type={this.props.iconType}/>}{text}
            </Button>
        )
    }
}
export default CustomBtn;